import { Controller } from "stimulus"
import axios from 'axios'

export default class extends Controller {
  static targets = ['metadata']

  initialize() {
    this.metadata = {
      reason:       this.metadataTarget.dataset.qleReason,
      qlek_reasons: JSON.parse(this.metadataTarget.dataset.qlekReasons),
      other_reason: this.metadataTarget.dataset.otherReason,
      market:       this.metadataTarget.dataset.qleMarket,
      draft:        this.metadataTarget.dataset.qleDraft
    }
    var market = document.getElementById('market_kind').querySelector('input[type=radio]:checked')
    this.disableOrEnable(market)
    this.initializeReasons()
    this.showorhideOtherReason()
    this.toggleDocumentCategories()
  }

    initializeReasons(){
      var qlek_reasons = this.metadata.qlek_reasons
      var reason_options = document.querySelector("#reasonContainer select")

      function getOptionValues(options) {
        return Array.from(options).map(option => option.value);
      }

      function getOptionLabels(options) {
        return Array.from(options).map(option => option.label.toLocaleLowerCase());
      }

      function formatReason(reason) {
        return reason.toLocaleLowerCase().split('_').join(' ');
      }

      var reasonFromValue = getOptionValues(reason_options.options);
      var reasonFromLabel = getOptionLabels(reason_options.options);

      for (var qlek_reason of qlek_reasons) {
        var reasonMatchesWithTagValue = reasonFromValue.includes(qlek_reason);
        var reasonMatchesWithTagLabel = reasonFromLabel.includes(qlek_reason.toLocaleLowerCase());
        var reasonMatchesWithTagLabelFormatted = reasonFromLabel.includes(formatReason(qlek_reason));

        if (!(reasonMatchesWithTagValue || reasonMatchesWithTagLabel || reasonMatchesWithTagLabelFormatted)) {
          reason_options.options[reason_options.options.length] = new Option(formatReason(qlek_reason), qlek_reason);
        }
      }

      reason_options.options[reason_options.options.length] = new Option("other", "other");
      this.setSelectedReason();
      if (this.metadata.reason != undefined) {
        this.checkSelectedReason();
      }
    }

    reasonChange(event) {
      var reason = document.querySelector("#reasonContainer select").value
      this.showorhideOtherReason()
    }

    checkSelectedReason() {
      var reason = this.metadata.reason
      var other_reason = this.metadata.other_reason
      var reasons = document.querySelector("#reasonContainer select").options
      var sele_reason = reason == "other" && other_reason ? "other" : reason
      for (var reason of reasons) {
        if (sele_reason == reason.value) {
          reason.selected = true
        }
      }
    }

    setSelectedReason(){
      var reason = this.metadata.reason
      var other_reason = this.metadata.other_reason
      var reason_options = document.querySelector("#reasonContainer select")
      if (reason == "Choose..." ) return;
      var sele_reason = reason == "other" && other_reason ? "other" : reason
      if (sele_reason.length != 0 && Array.from(reason_options.options).map(option => option.value).includes(sele_reason) == false){
        reason_options.options[reason_options.options.length] = new Option(sele_reason.toLocaleLowerCase().split('_').join(' '), sele_reason)
      }
    }

    showorhideOtherReason(){
      var other_reason = this.metadata.other_reason
      var reason = document.querySelector("#reasonContainer select").value
      if (other_reason != "" && reason == "other" || reason == "other"){
        document.getElementById("other_reason").setAttribute("type", "show");
        document.getElementById("other_reason").setAttribute("required", "required");
        document.getElementById("other_reason").classList.remove("hidden");
        if (document.querySelector("label[for='other_reason']")) {
          document.querySelector("label[for='other_reason']").style.display = "block";
        }
      }else{
        document.getElementById("other_reason").setAttribute("type", "hidden");
        document.getElementById("other_reason").removeAttribute("required");
        document.getElementById("other_reason").classList.add("hidden");
        if (document.querySelector("label[for='other_reason']")) {
          document.querySelector("label[for='other_reason']").style.display = "none";
        }
      }
    }

  disableTerminationkinds(market){
    var termination_on_kinds= document.getElementById('termination_on_kinds').querySelectorAll('input[type=checkbox]')
    for (var termination_on_kind of termination_on_kinds){
      termination_on_kind.disabled = false
      termination_on_kind.checked = false
        //TODO: fix this
      termination_on_kind.parentElement.parentElement.parentElement.querySelectorAll('input[type=text]')[0].disabled = false
    }
    if (market.value == "individual"){
      for (var termination_on_kind of termination_on_kinds){
        termination_on_kind.disabled = true
        termination_on_kind.checked = false
          //TODO: fix this
        termination_on_kind.parentElement.parentElement.parentElement.querySelectorAll('input[type=text]')[0].disabled = true
      }
    }else {
      for (var termination_on_kind of termination_on_kinds) {
        termination_on_kind.disabled = false
          //TODO: fix this
        termination_on_kind.parentElement.parentElement.parentElement.querySelectorAll('input[type=text]')[0].disabled = false
      }
    }
    if (this.metadataTarget.dataset.effectiveKinds != undefined){
      this.checkSelectedTerminationKinds()
    }
  }

  marketChange(event) {
    var market = document.getElementById('market_kind').querySelectorAll('input[type=radio]:checked')[0]
    if (this.metadataTarget.dataset.terminationKinds != undefined) {
      this.checkSelectedEffectiveKinds()
    }
    this.disableTerminationkinds(market);
  }

  checkSelectedTerminationKinds(){
    var termination_on_kinds= document.getElementById('termination_on_kinds').querySelectorAll('input[type=checkbox]')
    var market = document.getElementById('market_kind').querySelectorAll('input[type=radio]:checked')[0]
    var sele_market = this.metadata.market
    var selected_term_on_kinds = JSON.parse(this.metadataTarget.dataset.terminationKinds)
    for (var termination_on_kind of termination_on_kinds){
      if(selected_term_on_kinds.includes(termination_on_kind.value) == true && sele_market == market.value){
        termination_on_kind.checked = true
        termination_on_kind.disabled = false
        termination_on_kind.parentElement.parentElement.parentElement.querySelectorAll('input[type=text]')[0].disabled = false
      }
    }
  };

  checkSelectedEffectiveKinds(){
    var effective_on_kinds= document.getElementById('effective_on_kinds').querySelectorAll('input[type=checkbox]')
    var market = document.getElementById('market_kind').querySelectorAll('input[type=radio]:checked')[0]
    var sele_market = this.metadata.market
    var selected_effec_on_kinds = JSON.parse(this.metadataTarget.dataset.effectiveKinds)
    for (var effective_on_kind of effective_on_kinds){
      if(selected_effec_on_kinds.includes(effective_on_kind.value) == true && sele_market == market.value){
        effective_on_kind.checked = true
        effective_on_kind.disabled = false
        if (effective_on_kind.parentElement.parentElement.parentElement.querySelectorAll('input[type=text]')[0]) {
          effective_on_kind.parentElement.parentElement.parentElement.querySelectorAll('input[type=text]')[0].disabled = false
        }
      }
    }
  }

  disableOrEnable(market){
    if(this.metadata.draft == "false") {
      var inputs = document.getElementsByTagName("input");
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].disabled = true;
      }
      var checkbox = document.querySelectorAll('input[type=checkbox]');
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].disabled = true;
      }
      var inputs = document.getElementsByTagName("select");
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].disabled = true;
      }
    }else{
      var inputs = document.getElementsByTagName("input");
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].disabled = false;
      }
      var checkbox = document.querySelectorAll('input[type=checkbox]');
      for (var i = 0; i < checkbox.length; i++) {
        checkbox[i].disabled = false;
      }
      if (this.metadataTarget.dataset.terminationKinds != undefined) {
        this.checkSelectedEffectiveKinds()
      }
      this.disableTerminationkinds(market)
    }
  }

  // SEP Verification (:sep_verification): the "Required Document Category" multi-select. All of these
  // no-op when the section is absent (flag off), so the rest of the form is unaffected.
  documentCategoriesSection() {
    return document.getElementById('acceptable_document_categories')
  }

  // Show the categories only when Documentation Required = Yes; hiding clears the selection so a
  // "No" SEP submits no categories. Mirrors the approved mockup (field appears on Yes).
  toggleDocumentCategories() {
    var section = this.documentCategoriesSection()
    if (!section) return

    var documentsRequired = document.querySelector('#documents_required input[type=radio]:checked')
    var show = documentsRequired != null && documentsRequired.value === 'true'

    if (show) {
      section.classList.remove('hidden')
    } else {
      section.classList.add('hidden')
      section.querySelectorAll('input[type=checkbox]').forEach(function (box) { box.checked = false })
      this.collapseAllCategoryDocuments()
    }
    this.updateSubmitState()
  }

  // Expand/collapse one category's read-only acceptable-documents list.
  toggleCategoryDocuments(event) {
    var button = event.currentTarget
    var documents = document.getElementById('adc_docs_' + button.dataset.categoryId)
    if (!documents) return

    var expanded = documents.classList.toggle('hidden') === false
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false')
    button.textContent = expanded ? '⌄' : '›' // downward vs. right chevron
  }

  collapseAllCategoryDocuments() {
    var section = this.documentCategoriesSection()
    if (!section) return

    section.querySelectorAll('[id^="adc_docs_"]').forEach(function (documents) { documents.classList.add('hidden') })
    section.querySelectorAll('button[data-category-id]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false')
      button.textContent = '›'
    })
  }

  // A documentation-required SEP needs at least one category, so every submit button (Create/Update
  // draft and Publish) is disabled until one is selected while the categories are shown. No-op when
  // the section is hidden (Documentation Required = No).
  updateSubmitState() {
    var section = this.documentCategoriesSection()
    if (!section) return

    var form = this.element.closest('form')
    if (!form) return

    var visible = !section.classList.contains('hidden')
    var anyChecked = section.querySelectorAll('input[type=checkbox]:checked').length > 0
    var disable = visible && !anyChecked

    form.querySelectorAll('input[type=submit]').forEach(function (button) {
      button.disabled = disable
    })
  }
}
